import { render, staticRenderFns } from "./widgetPiechart.vue?vue&type=template&id=7077f57c&scoped=true&"
import script from "./widgetPiechart.vue?vue&type=script&lang=js&"
export * from "./widgetPiechart.vue?vue&type=script&lang=js&"
import style0 from "./widgetPiechart.vue?vue&type=style&index=0&id=7077f57c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7077f57c",
  null
  
)

export default component.exports